import { render, staticRenderFns } from "./ImportUnitsMeasurement.vue?vue&type=template&id=dec88328&scoped=true"
import script from "./ImportUnitsMeasurement.vue?vue&type=script&lang=js"
export * from "./ImportUnitsMeasurement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec88328",
  null
  
)

export default component.exports